export default {
  get name() {
    return 'ExponentWebBrowser';
  },
};
